<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 v-if="!loading" class="d-flex justify-content-center">Assign Projects to {{user.displayName}}</h1>
                    </div>
                </div>
            </div>
        </div>
        <b-spinner class="center-spinner" v-if="loading" variant="primary" label="Spinning"></b-spinner>
        <div class="container" v-if="!loading">
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Assigned Projects">
                        <ul>
                            <li v-if="userProjects && userProjects.length == 0">None</li>
                            <li v-for="userProject in userProjects">
                                {{userProject.text}}
                                <button type="button" :disabled="!userProject.canDelete" :title="userProject.canDelete ? '': 'Project is associated to a users existing TER or MER.'" class="close" style="float:none;" @click="showConfirmModal(userProject.id)">
                                    <span>&times;</span>
                                </button>
                                <modal title="Confirm delete?" :is-small="true" v-if="show_modal" @close="show_modal = false">
                                    <div class="modal-body">
                                        Are you sure you want to remove this item?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-primary" @click="deleteProject">Delete</button>
                                        <button type="button" class="btn btn-primary" @click="hideModal">Cancel</button>
                                    </div>
                                </modal>
                            </li>
                        </ul>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Assign new project">
                        <b-form-select class="w-50" v-model="selectedProject" :options="selectProjects" @change="selectProject($event)" value-field="id">
                            <template #first>
                                <option :value="null" disabled>Select</option>
                            </template>

                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-12">
                    <button @click="back" class="btn btn-secondary btn-lg mr-2">Back</button>
                    <button @click="save" :disabled="inProgress" class="btn btn-primary btn-lg">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    // @ is an alias to /src
    import ProjectService from '@/services/ProjectService';
    import UserService from '@/services/UserService';
    import modal from '@/components/modal';

    export default {
        name: 'projectusersedit',
        components: {
            modal
        },
        data: function () {
            return {
                selectedProject: null,
                userId: null,
                user: null,
                loading: true,
                projects: null,
                selectProjects: [],
                userProjects: null,
                inProgress: false,
                userProjectsInUse: [],
                promptSave: false,
                returnUrl: null,
                show_modal: false,
                itemToDelete: null
            }
        },
        created() {
            this.userId = this.$route.params.id;
        },
        async beforeMount() {
            this.user = await UserService.getUser(this.userId);
            this.projects = await ProjectService.getActiveProjects();
            this.userProjects = await ProjectService.getUserProjects(this.userId);
            this.userProjectsInUse = await ProjectService.getUserProjectsInUse(this.userId);
            this.userProjects.forEach((p) => {
                p.canDelete = this.userProjectsInUse.indexOf(p.id) < 0;
                p.text = p.projectNumber + ' - ' + p.projectName;
            });
            
            this.projects.forEach((p) => p.text = p.projectNumber + ' - ' + p.projectName)
            this.selectProjects = this.projects.filter((p) => !this.userProjects.find((up) => up.id == p.id));
            this.loading = false;
        },
        mounted() {
            let returnExpenseReportID = this.$route.query.returnExpenseReportID;
            if (returnExpenseReportID) {
                let returnIsMiscReport = this.$route.query.isMiscReport;
                this.returnUrl = (returnIsMiscReport ? '/misc-expense-report/' : '/review-submit/') + returnExpenseReportID;
                console.log(this.returnUrl);
            }
        },
        computed: {
            //deleteTooltip: function (canDelete) {

            //}
        },
        methods: {
            showConfirmModal(item) {
                this.show_modal = true;
                this.itemToDelete = item;
            },
            hideModal() {
                this.show_modal = false;
            },
            deleteProject() {
                this.removeUserProject(this.itemToDelete);
                this.show_modal = false;
            },
            selectProject(id) {
                let project = this.projects.find((p) => p.id == id);
                project.canDelete = true;
                this.userProjects.push(project)
                this.selectProjects = this.projects.filter((p) => !this.userProjects.find((up) => up.id == p.id));
                this.selectedProject = null;
                this.setPromptSave(true);
            },
            removeUserProject(id) {
                this.userProjects = this.userProjects.filter((p) => p.id != id);
                this.selectProjects = this.projects.filter((p) => !this.userProjects.find((up) => up.id == p.id));
                this.setPromptSave(true);
            },
            back() {
                if (this.returnUrl) {
                    this.$router.push({ path: this.returnUrl });
                }
                else if (this.userId) {
                    this.$router.push({ name: "project-users" });
                }
                else {
                    this.$router.push({ name: "expense-report" });
                }
            },
            async save() {
                this.inProgress = true;
                try {
                    let model = { userId: this.userId, projectIds: this.userProjects.map((p) => p.id) }
                    await ProjectService.saveProjectUsers(model);
                    this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "User Projects Updated" });
                    this.userProjects = await ProjectService.getUserProjects(this.userId);
                    this.selectProjects = this.projects.filter((p) => !this.userProjects.find((up) => up.id == p.id));
                    this.userProjects.forEach((p) => {
                        p.canDelete = this.userProjectsInUse.indexOf(p.id) < 0;
                    });
                    this.setPromptSave(false);

                    if (this.returnUrl) {
                        this.$router.push({ path: this.returnUrl });
                    }
                } catch (e) {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                }

                this.inProgress = false;
            },
            setPromptSave(val) {
                this.promptSave = val;
                if (val) {
                    window.onbeforeunload = function () {
                        return true;
                    };
                }
                else {
                    window.onbeforeunload = null;
                }
            }
        },
        async beforeRouteLeave(to, from, next) {
            if (this.promptSave) {
                if (confirm('Are you sure you want to leave this page without saving changes?')) {
                    next();
                }
                else {
                    next(false);
                }
            }
            else {
                next();
            }
        }
    }
</script>